
import { Col, Form, Input, Row, Select, Switch, message, Pagination } from 'antd';
import Box from '../../components/Box';
import Button from '../../components/Button';
import { Fragment, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import Swal from 'sweetalert2';
import accountApis from '../../services/accountApis';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import Table, { ColumnsType } from 'antd/es/table';
import { TableRowSelection } from 'antd/es/table/interface';
import { Content } from 'antd/es/layout/layout';
import { useDispatch } from 'react-redux';
import { setLoading } from '../../store/loading/actions';
import { formatCurrency, formatNumber } from '../../utils/formatCurrency';
import { CampaignStatusDropDown, HeaderCampaignFilter, TableCampaignContentStyled } from './SalonMarketingSmsCamp';

export const SalonMarketingEmailCamp = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [formSearch] = Form.useForm();

    const [lstEmailCampaign, setLstEmailCampaign] = useState<any>(null);
    const COUPON_ITEMS_PER_PAGE = 10;
    const [totalItems, setTotal] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);

    const getDataEmailCampaign = async (shopId: any, status: string | null, type: string | null, title: string | null, page: number, size: number) => {
        try {
            const response = await accountApis.filterEmailCampaignByShopId(shopId, status ? status : null, type, title, page, size);
            if (response.status === 200) {
                setLstEmailCampaign(response.data.data.content);
                setTotal(response.data.data.totalElements);
            } else {
                message.error({ content: response.data.message, duration: 2 });
            }
        } catch (error: any) {
            message.error({ content: error.message as string, duration: 2 });
        }
    };

    const onPageChanged = async (pageNumber: number) => {
        dispatch(setLoading(true));
        try {
            setCurrentPage(pageNumber);
            const values = await formSearch.validateFields();
            await getDataEmailCampaign(id, values.status, 'EMAIL', values.title, pageNumber, COUPON_ITEMS_PER_PAGE);
        } catch (error) {
            message.error({ content: 'Page has been deleted', duration: 2 });
        } finally {
            dispatch(setLoading(false));
        }
    };

    const onFinishFilter = async (values: any) => {
        dispatch(setLoading(true));
        try {
            setCurrentPage(1);
            await getDataEmailCampaign(id, values.status, 'EMAIL', values.title, 1, COUPON_ITEMS_PER_PAGE);
        } catch (error) {
            message.error({ content: 'Page has been deleted', duration: 2 });
        } finally {
            dispatch(setLoading(false));
        }
    };

    const handleOnChangeStatus = (record: any) => async (value: string) => {
        const result = await Swal.fire({
            title: '',
            html: 'Are you sure want to change status?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            confirmButtonColor: '#d42b3c',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
        });
        if (!result.isConfirmed) return;
        dispatch(setLoading(true));
        try {
            const response = await accountApis.updateCampaignStatus(id, value, record.id);
            if (response.status === 200) {
                message.success('Update successful');
                const detail = response?.data?.data;
                if (detail) {
                    const temp = [...lstEmailCampaign];
                    const idx = temp.findIndex(o => o.id === detail.id);
                    if (idx !== -1) {
                        temp[idx] = detail;
                        setLstEmailCampaign(temp);
                    }
                }

            } else {
                message.error({ content: response.data.message, duration: 2 });
            }
        } catch (error: any) {
            message.error({ content: error.message as string, duration: 1 });
        } finally {
            dispatch(setLoading(false));
        }
    };

    useEffect(() => {
        const initData = async () => {
            try {
                if (id && !lstEmailCampaign) {
                    dispatch(setLoading(true));
                    await getDataEmailCampaign(id, null, 'EMAIL', null, currentPage, COUPON_ITEMS_PER_PAGE);
                    dispatch(setLoading(false));
                }
            }
            catch (error: any) {
                message.error({ content: error.message as string, duration: 2 });
            }
        };
        initData();
    }, []);

    const columns: ColumnsType<any> = [
        {
            title: <p>TITLE</p>,
            dataIndex: 'title',
            className: 'title',
            render: (title: string) => <a>{title}</a>,
        },
        {
            title: <p>SEND TIME</p>,
            dataIndex: 'sendTime',
            className: 'sendTime',
            render: (sendTime: string) =>
                <span>{sendTime}</span>
        },
        {
            title: 'PROMOTION',
            dataIndex: 'promotionValue',
            className: 'promotionValue',
            render: (promotionValue: string, promotionType: string) =>
                <span>{promotionType === 'PERCENT' ? `${promotionValue}%` : formatCurrency(promotionValue)}</span>,
        },
        {
            title: 'CUSTOMER',
            dataIndex: 'totalCustomer',
            className: 'totalCustomer',
            render: (totalCustomer: string) =>
                <span>{totalCustomer ? formatNumber(totalCustomer) : '--'}</span>,
        },
        {
            title: <p>TOTAL SMS</p>,
            dataIndex: 'totalSms',
            className: 'totalSms',
            render: (totalSms: string) =>
                <span>{totalSms ? formatNumber(totalSms) : '--'}</span>
        },
        {
            title: <p>CREATED DATE</p>,
            dataIndex: 'createDated',
            className: 'createDated',
            render: (createDated: string) =>
                <span>{createDated}</span>
        },
        {
            title: 'STATUS',
            dataIndex: 'status',
            render: (status: string, record: any) =>
                <Fragment>
                    <CampaignStatusDropDown
                        value={status}
                        onChange={handleOnChangeStatus(record)}
                    />
                </Fragment>
        },
        {
            title: <p style={{ textAlign: 'center' }}>ACTION</p>,
            render: (record: any) =>
                <Fragment>
                    {
                        <Box display="flex" justifyContent="center" alignItems="center" gap={0.2} style={{ height: '20px' }}>
                            <Switch
                                key={record.id}
                                checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />}
                                onChange={(checked) => handleSwitchChange(checked, record.id)}
                                checked={record.active}
                            />
                            <Button className='btn-delete' icon="delete" onClick={() => handleDelete(record.id, record.title)}></Button>
                            <Button className='btn-edit' icon="edit" onClick={() => handleEditCampaign(record.id, record.status)}></Button>
                        </Box>
                    }
                </Fragment>
        },
    ];

    const handleEditCampaign = async (emailId: string, ststus: string) => {
        if (ststus == 'SENT' || ststus == 'CANCEL') {
            message.warning('Not edit because ststus is ' + ststus);
            return;
        }
        navigate(`/marketing/${id}/email-campaign/${emailId}/update`);
    };

    const handleDelete = async (emailId: string, title: string) => {
        const result = await Swal.fire({
            title: title,
            html: 'Are you sure want to delete Email?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete it',
            confirmButtonColor: '#d42b3c',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
        });
        if (result.isConfirmed) {
            dispatch(setLoading(true));
            try {
                const campIds: any[] = [
                    emailId
                ];
                const response = await accountApis.deleteMultipleCampaign(campIds);
                if (response.status === 200) {
                    message.success('Delete successful');
                    await onPageChanged(currentPage);
                } else {
                    message.error({ content: response.data.message, duration: 2 });
                }
            } catch (error: any) {
                message.error({ content: error.message as string, duration: 1 });
            } finally {
                dispatch(setLoading(false));
            }
        }
    };

    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection: TableRowSelection<any> = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const handleSwitchChange = async (checked: any, campaignId: any) => {
        const result = await Swal.fire({
            title: '',
            html: 'Are you sure?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            confirmButtonColor: '#6FABB6',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
        });
        if (!result.isConfirmed) return;
        try {
            const res = await accountApis.inactiveCampaign(id, campaignId, checked);
            if (res.status === 200) {
                message.success('Update successful');
                const detail = res?.data?.data;
                if (detail) {
                    const temp = [...lstEmailCampaign];
                    const idx = temp.findIndex(o => o.id === detail.id);
                    if (idx !== -1) {
                        temp[idx] = detail;
                        setLstEmailCampaign(temp);
                    }
                }
            }
        } catch (error: any) {
            message.error({ content: error.message as string, duration: 2 });
        }
    };


    return (
        <ContentStyled>
            <Form form={formSearch} onFinish={onFinishFilter}>
                <HeaderCampaignFilter extendButton={
                    <Button ml={1} variant="PRIMARY" icon="add" onClick={() => navigate(`/marketing/${id}/email-campaign/create`)}>
                        Create EMAIL Campaign
                    </Button>
                } />
            </Form>

            <TableCampaignContentStyled
                columns={columns}
                dataSource={lstEmailCampaign}
                rowKey="id"
                pagination={false} />

            <PagingStyled>
                <Pagination
                    current={currentPage}
                    total={totalItems}
                    pageSize={COUPON_ITEMS_PER_PAGE}
                    onChange={onPageChanged}
                    showSizeChanger={false}
                />
            </PagingStyled>
        </ContentStyled>
    )
}

const ContentStyled = styled.div`
    background: rgba(255, 255, 255, 1);
    margin-top: 0.5rem;
    padding: 1rem;
`;

const PagingStyled = styled(Content)`
  text-align: right;
  margin-top: 10px;
  background: rgba(255, 255, 255, 1);
`;